import React from 'react';

// Define the interface for the props
interface LoremJokesumPlaceholderProps {
    question: string;
    answer: string;
}

// Create the LoremJokesumPlaceholder component
const LoremJokesumPlaceholder: React.FC<LoremJokesumPlaceholderProps> = ({ question, answer }) => {
    return (
        <div style={styles.container}>
            <h2 style={styles.question}>{question}</h2>
            <p style={styles.answer}>{answer}</p>
            <p>this is a placeholder</p>
        </div>
    );
};

// Styles for the component
const styles = {
    container: {
        padding: '20px',
        margin: '10px 0',
        backgroundColor: '#f9f9f9',
        borderRadius: '8px',
        border: '1px solid #ddd',
        boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
    },
    question: {
        fontSize: '1.5em',
        marginBottom: '10px',
        color: '#333',
    },
    answer: {
        fontSize: '1.2em',
        color: '#555',
    },
};

export default LoremJokesumPlaceholder;
